// extracted by mini-css-extract-plugin
export var errorsContainer = "_s6-1";
export var link = "_s6-0";